import {Injectable} from '@angular/core';
import {GlobalMessageType, TranslationService} from '@spartacus/core';
import {CyberSourcePaymentState} from '@app/payment/services/store/payment-state';
import {IDcpGlobalErrorMessage} from '@dcp/configurator';
import {Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CyberSourcePaymentErrorService {
  constructor(private translationService: TranslationService) {}

  getMessage(state: CyberSourcePaymentState): Observable<IDcpGlobalErrorMessage> {
    return this.translationService.translate('common.errors.somethingWrong').pipe(
      first(),
      map((msg) => {
        return this.buildDisposableMessage(msg, GlobalMessageType.MSG_TYPE_ERROR, false);
      })
    );
  }

  private buildDisposableMessage(
    message: string,
    type: GlobalMessageType,
    showSupportLink: boolean
  ): IDcpGlobalErrorMessage {
    return {
      message,
      type,
      showSupportLink,
    };
  }
}
